#import "../fragments/user-email-calendar-statuses-fragment.graphql"

query GetEmailCalendarStatuses {
    loggedInUser {
        ...UserEmailCalendarStatusesFragment
    }
}
